/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */
let token = document.head.querySelector('meta[name="csrf-token"]')
if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

/**
 * Nav account menu.
 */
let navAccountBtn = document.querySelector('.nav-account__user-icon')

if (navAccountBtn && navAccountBtn !== null){
  navAccountBtn.addEventListener('click', function(e) {
    let navMenu = document.querySelector('.nav-account__submenu')
    
    if (navMenu.classList.contains('nav-account__submenu--show')) {
      navMenu.classList.remove('nav-account__submenu--show')
    } else {
      navMenu.classList.add('nav-account__submenu--show')
    }
  })
}

/**
 * Enable/disable form submit button(s) on change.
 */
enableFormSubmitButtonOnChange()

function enableFormSubmitButtonOnChange() {
  const forms = document.querySelectorAll('form.submittable-on-change')
  if (forms) {
    forms.forEach(form => {
      let initFormData = new FormData(form)

      form.querySelectorAll('input, select, textarea').forEach(inpt => {
        inpt.addEventListener('change', testForChange.bind(event, form, initFormData))
        inpt.addEventListener('keyup', testForChange.bind(event, form, initFormData))
      })
    })
  }

  function testForChange(form, initFormData) {
    const formData = new FormData(form)
    const submitButton = form.querySelector('button[type="submit"]')

    if (JSON.stringify([...initFormData.entries()]) !== JSON.stringify([...formData.entries()])) {
      submitButton.disabled = false
    } else {
      submitButton.disabled = true
    }
  }
}

/**
 * Marketing video modal.
 */
let iframe = document.querySelector('#modal-marketing-video iframe'),
    player = new Vimeo.Player(iframe),
    modal = document.querySelector('#modal-marketing-video')

document.querySelectorAll('.modal-video-open').forEach(function(item) {
  item.addEventListener('click', function() {
    modal.classList.add('active')
    player.play()
  })
})

document.querySelector('#modal-video-close').addEventListener('click', function() {
  modal.classList.remove('active')
  player.pause()
})

player.on('ended', function() {
  modal.classList.remove('active')
})

const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)
const playParam = urlParams.get('play')

if (playParam) {
  modal.classList.add('active')
}

/**
 * Accordions.
 */
if (document.querySelector('.accordion')) {

  document.querySelectorAll('.accordion .accordion__question').forEach(question => {
    question.addEventListener('click', function(e) {
      e.preventDefault()
      let answer = question.nextElementSibling

      // Close
      if (question.classList.contains('active')) {
        question.classList.remove('active')
        question.querySelector('.fa').classList.remove('fa-minus-circle')
        question.querySelector('.fa').classList.add('fa-plus-circle')

        answer.style.maxHeight = null

      // Open
      } else {
        question.classList.add('active')
        question.querySelector('.fa').classList.remove('fa-plus-circle')
        question.querySelector('.fa').classList.add('fa-minus-circle')

        answer.style.maxHeight = answer.scrollHeight + 'px'
      }
    })
  })
}

/**
 * Collapse.
 * 
 * The trigger requires the "trigger-collapse" class, as well 
 * as the "data-collapse-target" attribute, whose value
 * is the selector of the dom element to show/hide.
 * If the trigger is a checkbox, then the target will be
 * shown when it is checked.
 */
document.querySelectorAll('.trigger-collapse').forEach(trigger => {
  trigger.addEventListener('click', (e) => {
    let target = trigger.dataset('collapse-target')

    if (trigger.matches('[type="checkbox"]')) {
      if (trigger.checked = true) {
        target.classList.remove('hidden')
      } else {
        target.classList.add('hidden')
      }
    } else {
      target.toggleClass('hidden')
    }
  })
})

/**
 * Initialize reCaptcha v3.
 * 
 * Applies to all forms having the "has-captcha" class.
 *
 * @param  {String}  verifyUrl  The token verification URL
 * @param  {String}  siteKey    reCaptcha site key
 * @param  {String}  viewName   Laravel view name
 */
window.initReCaptcha = (verifyUrl, siteKey, viewName) => {

  // Page load
  // grecaptcha.execute(siteKey, {action: 'pageload/' + viewName})
  //   .then((token) => {
  //     axios.post(verifyUrl, {token: token, action: 'pageload/' + viewName})
  //       .then((response) => {
  //         // Success
  //       })
  //       .catch((error) => {
  //         // console.log(error)
  //         document.querySelectorAll('form.has-captcha').forEach(form => {
  //           form.remove()
  //         })
  //       })
  //   }, (error) => {
  //     // console.log(error)
  //   })

  // Form submission
  document.querySelectorAll('form.has-captcha').forEach(form => {
    form.addEventListener('submit', (e) => {

      if (! form.querySelector('input[name="captcha_token"]')) {
        e.preventDefault()
        
        form.querySelector('button[type="submit"]').disabled = true
        
        grecaptcha.execute(siteKey, {action: 'formsubmission/' + viewName})
          .then((token) => {

            let tokenInput = document.createElement('input')
            tokenInput.setAttribute('type', 'hidden')
            tokenInput.setAttribute('name', 'captcha_token')
            tokenInput.setAttribute('value', token)

            let actionInput = document.createElement('input')
            actionInput.setAttribute('type', 'hidden')
            actionInput.setAttribute('name', 'captcha_action')
            actionInput.setAttribute('value', 'formsubmission/' + viewName)

            form.prepend(tokenInput)
            form.prepend(actionInput)

            form.submit()

          }, (error) => {
            console.log(error)
          })
      }
    })
  })
}
